import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col min-w-full min-h-full col-span-1 text-center bg-white border divide-y divide-gray-200 shadow-sm saturate-100 hover:saturate-200 rounded-t-2xl" }
const _hoisted_2 = { class: "flex flex-col flex-1 px-8 py-6 space-y-3" }
const _hoisted_3 = ["href", "alt", "title"]
const _hoisted_4 = ["src", "alt", "title"]
const _hoisted_5 = ["href", "alt", "title"]
const _hoisted_6 = { class: "text-xl" }
const _hoisted_7 = {
  key: 0,
  class: "mb-2 text-sm text-slate-600"
}
const _hoisted_8 = { class: "flex flex-col justify-between flex-grow mt-1" }
const _hoisted_9 = {
  key: 0,
  class: "px-3 py-2 my-3 text-xs font-bold text-center uppercase rounded-lg bg-slate-200 text-clay-700"
}
const _hoisted_10 = { class: "text-sm text-clay-800" }
const _hoisted_11 = {
  key: 1,
  class: "justify-center flex items-center gap-x-1.5",
  title: "This entity has active opportunities"
}
const _hoisted_12 = { class: "text-xs leading-5 text-clay-800" }
const _hoisted_13 = ["href", "alt", "title"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 2,
  class: "justify-center flex items-center gap-x-1.5",
  title: "This entity has active alumni"
}
const _hoisted_17 = { class: "text-xs leading-5 text-clay-800" }
const _hoisted_18 = ["href", "alt", "title"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "flex justify-center pt-6 text-sm" }

import {computed, onMounted, Ref, ref} from "vue";
import Bookmarking from "@/main/components/Bookmarking.vue";
import Fanning from "@/main/components/Fanning.vue";
import {TheatreCompanyDTO} from "@/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'TheatreCompanyCard',
  props: {
    company: {},
},
  setup(__props) {

// @ts-ignore
const props = __props

const company: TheatreCompanyDTO = props.company;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: `/theatre-companies/${_unref(company).intId}/${_unref(company).slug}`,
        alt: _unref(company).name,
        title: _unref(company).name,
        class: "guide-img-container"
      }, [
        _createElementVNode("img", {
          class: "mx-auto shrink-0 rounded-2xl max-h-32",
          src: _unref(company).logoUrl,
          alt: _unref(company).name,
          title: _unref(company).name
        }, null, 8, _hoisted_4)
      ], 8, _hoisted_3),
      _createElementVNode("a", {
        href: `/theatre-companies/${_unref(company).intId}/${_unref(company).slug}`,
        alt: _unref(company).name,
        title: _unref(company).name,
        class: "text-lg font-medium text-gray-900 hover:underline hover:decoration-slate-900 hover:transition-all hover:decoration-2"
      }, [
        _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(company).name), 1)
      ], 8, _hoisted_5),
      (_unref(company).shortAddressPrettified?.length > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(company).shortAddressPrettified), 1))
        : _createCommentVNode("", true),
      _createElementVNode("dl", _hoisted_8, [
        (_unref(company).isNoLongerActive)
          ? (_openBlock(), _createElementBlock("dd", _hoisted_9, " No longer active "))
          : _createCommentVNode("", true),
        _cache[0] || (_cache[0] = _createElementVNode("dt", { class: "sr-only" }, "Types", -1)),
        _createElementVNode("dd", _hoisted_10, _toDisplayString(_unref(company).types?.join(", ")), 1)
      ]),
      (_unref(company).opportunityCount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-none p-1 rounded-full bg-emerald-500/20" }, [
              _createElementVNode("div", { class: "h-1.5 w-1.5 rounded-full bg-emerald-500" })
            ], -1)),
            _createElementVNode("p", _hoisted_12, [
              _createElementVNode("a", {
                href: `/theatre-companies/${_unref(company).intId}/${_unref(company).slug}#opportunities`,
                alt: `Opportunities for ${_unref(company).name}`,
                title: `Opportunities for ${_unref(company).name}`,
                class: "border-b hover:border-none"
              }, [
                _createTextVNode(_toDisplayString(_unref(company).opportunityCount) + " active ", 1),
                (_unref(company).opportunityCount === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "opportunity"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15, "opportunities"))
              ], 8, _hoisted_13)
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(company).alumniCount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-none p-1 rounded-full bg-clay-200/20" }, [
              _createElementVNode("div", { class: "h-1.5 w-1.5 rounded-full bg-clay-500" })
            ], -1)),
            _createElementVNode("p", _hoisted_17, [
              _createElementVNode("a", {
                href: `/theatre-companies/${_unref(company).intId}/${_unref(company).slug}#alumni`,
                alt: `Alumni for ${_unref(company).name}`,
                title: `Alumni for ${_unref(company).name}`,
                class: "border-b hover:border-none"
              }, [
                _createTextVNode(_toDisplayString(_unref(company).alumniCount) + " ", 1),
                (_unref(company).alumniCount === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, "alumnus"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_20, "alumni"))
              ], 8, _hoisted_18)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(Fanning, {
          id: _unref(company).id,
          "number-of-fans": _unref(company).fanCount
        }, null, 8, ["id", "number-of-fans"]),
        _createVNode(Bookmarking, {
          id: _unref(company).id
        }, null, 8, ["id"])
      ])
    ])
  ]))
}
}

})